import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import MenuUtils from '../utils/menuUtils.js';
import { getTokenInfo } from '../utils/auth'
import menulistjson from "../data/menulistjson.js"

Vue.use(Router)

const createRouter = () => new Router({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const router = createRouter()

//在路由跳转的时候同一个路由多次添加是不被允许的
//重写路由的push方法
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

// 获取用户登录信息
const _tokenInfo = getTokenInfo()
// 判断是否已存在菜单列表
// var menuData = JSON.stringify(getMenu())
var menuData = []
if(_tokenInfo){
  // 未登录状态不加载菜单路由
  menulistjson(menuData)
}
menuData = JSON.stringify(menuData).toLowerCase()
if (menuData != 'null') {
  let routes = []
  MenuUtils(routes, menuData)
  router.options.routes = Object.assign(router.options.routes, routes)
  router.addRoutes(routes)
}

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router


// WEBPACK FOOTER //
// ./src/modules/web/router/index.js